export default "__VITE_ASSET__CuDCFQWD__"